/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Label_StarterInputs */



/**
* | output |
* | --- |
* | "Starter" |
*
* @param {Plan_Tab_Label_StarterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_label_starter = /** @type {((inputs?: Plan_Tab_Label_StarterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Label_StarterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starter")
	return /** @type {LocalizedString} */ ("Starter")
});